// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/party.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddPartyCommentRequest, AddPartyRoleRequest, BulkDeletePartiesRequest, BulkDeletePartiesResponse, Channel, CreateChannelRequest, CreateFieldDefinitionRequest, CreatePartyRequest, CreatePartySupplierFeedRequest, CustomerOrderStats, DeleteFieldDefinitionRequest, DeletePartyRequest, DeletePartySupplierFeedRequest, GetCustomerOrderStatsRequest, GetPartyPreferencesRequest, GetPartyRequest, LinkPartiesRequest, ListClientInvitesRequest, ListClientInvitesResponse, ListFieldDefinitionsRequest, ListFieldDefinitionsResponse, ListPartiesRequest, ListPartiesResponse, ListPartyProductsRequest, ListPartyProductsResponse, ListPartySupplierFeedsRequest, ListPartySupplierFeedsResponse, Party, PartyFieldDefinition, PartyPreferences, PartyRelationship, PartySupplierFeed, RemovePartyProductsRequest, RemovePartyRoleRequest, SendClientInviteRequest, SendClientInviteResponse, SetPartyProductsRequest, UnlinkPartiesRequest, UpdateFieldDefinitionRequest, UpdatePartyPreferencesRequest, UpdatePartyRequest, UpdatePartySupplierFeedRequest } from "./party_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";
import { ActivityEntry } from "./activity_pb.js";

/**
 * @generated from service omnios.v1.PartyService
 */
export const PartyService = {
  typeName: "omnios.v1.PartyService",
  methods: {
    /**
     * @generated from rpc omnios.v1.PartyService.CreateParty
     */
    createParty: {
      name: "CreateParty",
      I: CreatePartyRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.GetParty
     */
    getParty: {
      name: "GetParty",
      I: GetPartyRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.UpdateParty
     */
    updateParty: {
      name: "UpdateParty",
      I: UpdatePartyRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.DeleteParty
     */
    deleteParty: {
      name: "DeleteParty",
      I: DeletePartyRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.ListParties
     */
    listParties: {
      name: "ListParties",
      I: ListPartiesRequest,
      O: ListPartiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.CreateChannel
     */
    createChannel: {
      name: "CreateChannel",
      I: CreateChannelRequest,
      O: Channel,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.LinkParties
     */
    linkParties: {
      name: "LinkParties",
      I: LinkPartiesRequest,
      O: PartyRelationship,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.UnlinkParties
     */
    unlinkParties: {
      name: "UnlinkParties",
      I: UnlinkPartiesRequest,
      O: PartyRelationship,
      kind: MethodKind.Unary,
    },
    /**
     * Field definitions for CRM
     *
     * @generated from rpc omnios.v1.PartyService.CreateFieldDefinition
     */
    createFieldDefinition: {
      name: "CreateFieldDefinition",
      I: CreateFieldDefinitionRequest,
      O: PartyFieldDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.UpdateFieldDefinition
     */
    updateFieldDefinition: {
      name: "UpdateFieldDefinition",
      I: UpdateFieldDefinitionRequest,
      O: PartyFieldDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.DeleteFieldDefinition
     */
    deleteFieldDefinition: {
      name: "DeleteFieldDefinition",
      I: DeleteFieldDefinitionRequest,
      O: PartyFieldDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.ListFieldDefinitions
     */
    listFieldDefinitions: {
      name: "ListFieldDefinitions",
      I: ListFieldDefinitionsRequest,
      O: ListFieldDefinitionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.BulkDeleteParties
     */
    bulkDeleteParties: {
      name: "BulkDeleteParties",
      I: BulkDeletePartiesRequest,
      O: BulkDeletePartiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Party roles
     *
     * @generated from rpc omnios.v1.PartyService.AddPartyRole
     */
    addPartyRole: {
      name: "AddPartyRole",
      I: AddPartyRoleRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.RemovePartyRole
     */
    removePartyRole: {
      name: "RemovePartyRole",
      I: RemovePartyRoleRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * Party preferences
     *
     * @generated from rpc omnios.v1.PartyService.GetPartyPreferences
     */
    getPartyPreferences: {
      name: "GetPartyPreferences",
      I: GetPartyPreferencesRequest,
      O: PartyPreferences,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.UpdatePartyPreferences
     */
    updatePartyPreferences: {
      name: "UpdatePartyPreferences",
      I: UpdatePartyPreferencesRequest,
      O: PartyPreferences,
      kind: MethodKind.Unary,
    },
    /**
     * Customer stats
     *
     * @generated from rpc omnios.v1.PartyService.GetCustomerOrderStats
     */
    getCustomerOrderStats: {
      name: "GetCustomerOrderStats",
      I: GetCustomerOrderStatsRequest,
      O: CustomerOrderStats,
      kind: MethodKind.Unary,
    },
    /**
     * Comments / timeline
     *
     * @generated from rpc omnios.v1.PartyService.AddPartyComment
     */
    addPartyComment: {
      name: "AddPartyComment",
      I: AddPartyCommentRequest,
      O: ActivityEntry,
      kind: MethodKind.Unary,
    },
    /**
     * Party product availability (Feature B: which of our products are available to this party)
     *
     * @generated from rpc omnios.v1.PartyService.SetPartyProducts
     */
    setPartyProducts: {
      name: "SetPartyProducts",
      I: SetPartyProductsRequest,
      O: ListPartyProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.RemovePartyProducts
     */
    removePartyProducts: {
      name: "RemovePartyProducts",
      I: RemovePartyProductsRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.ListPartyProducts
     */
    listPartyProducts: {
      name: "ListPartyProducts",
      I: ListPartyProductsRequest,
      O: ListPartyProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Client invitation (create Zitadel user, send invite email)
     *
     * @generated from rpc omnios.v1.PartyService.SendClientInvite
     */
    sendClientInvite: {
      name: "SendClientInvite",
      I: SendClientInviteRequest,
      O: SendClientInviteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.ListClientInvites
     */
    listClientInvites: {
      name: "ListClientInvites",
      I: ListClientInvitesRequest,
      O: ListClientInvitesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Per-supplier catalog feed configurations (multiple feeds per supplier).
     *
     * @generated from rpc omnios.v1.PartyService.ListPartySupplierFeeds
     */
    listPartySupplierFeeds: {
      name: "ListPartySupplierFeeds",
      I: ListPartySupplierFeedsRequest,
      O: ListPartySupplierFeedsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.CreatePartySupplierFeed
     */
    createPartySupplierFeed: {
      name: "CreatePartySupplierFeed",
      I: CreatePartySupplierFeedRequest,
      O: PartySupplierFeed,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.UpdatePartySupplierFeed
     */
    updatePartySupplierFeed: {
      name: "UpdatePartySupplierFeed",
      I: UpdatePartySupplierFeedRequest,
      O: PartySupplierFeed,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PartyService.DeletePartySupplierFeed
     */
    deletePartySupplierFeed: {
      name: "DeletePartySupplierFeed",
      I: DeletePartySupplierFeedRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
  }
};

